import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AccountModel } from '../../../../api/models/account-model';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-switch-modal',
  templateUrl: './switch-modal.component.html',
  standalone: false,
})
export class SwitchModalComponent {
  @Output() accountSwitched = new EventEmitter<AccountModel>();
  activeAccountGuid: string;

  constructor(
    public dialogRef: MatDialogRef<SwitchModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { availableAccounts: AccountModel[] },
    protected router: Router,
    private authService: AuthService,
  ) {
    this.activeAccountGuid = this.authService.getActiveAccountGuid()!;
  }

  swapAccount(account: AccountModel) {
    this.accountSwitched.emit(account);
    this.dialogRef.close();
  }

  createAccount() {
    void this.router.navigate(['admin', 'register'], {
      state: { isExistingUser: true },
    });

    this.dialogRef.close();
  }
}
